/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function History24({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="24"
      role="img"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11 7h2v4.586l2.707 2.707-1.414 1.414L11 12.414V7Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
      <path
        d="M12 4c4.4 0 8 3.6 8 8s-3.6 8-8 8c-4.062 0-7.442-3.067-7.938-7H2.05c.506 5.035 4.787 9 9.95 9 5.5 0 10-4.5 10-10S17.5 2 12 2a9.986 9.986 0 0 0-7.545 3.455L2 3v6.5h6.5L5.872 6.872A7.992 7.992 0 0 1 12 4Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
